import { Injectable } from "@angular/core";
import { AuthHttp } from "./auth.http";
import { ConfigStore } from '../stores/config.store';

@Injectable()
export class PropertiesService {        

    constructor(private http: AuthHttp, private config : ConfigStore) {        
    }

    private buildUrl(category: string, params: Array<any> = null): string {

        let baseUrl: string = this.config.getValue('webServiceURL');
        let result: string = baseUrl + '/api/';

        switch (category) {

            case 'R': result += 'qresidenziali'; break;

            default:
                throw new Error('Categoria non valida ('+ category +').');
        }

        if (params && params.length > 0) {

            let temp: string = '';

            for (let i = 0; i < params.length; i++) {

                let item: any = params[i];

                for (let p in item) {
                    temp += p + '=' + encodeURIComponent(item[p]) + '&';
                }
            }

            result += '?'+ temp.substr(0, temp.length - 1);
        }                        

        // console.log('[PropertiesService] buildUrl | url: ');
        // console.log(result);

        return result;
    }    

    list(category: string, params: Array<any> = null): any {
       
        var url: string = this.buildUrl(category, params);

        return this.http.get(
            url
        ).map(response => {

            let json = response.json();            

            return json;
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/properties.service.ts